import React from 'react';
import { Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import './style';

/**
 * 下拉选
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const MySelect = props => {
    const {
        style = {},
        selectStyle = {},
        options = [],
        handleChange,
        defaultValue,
        ...otherProps
    } = props;

    return (
        <div className="mySelect" style={{ ...style }}>
            <Select
                size="small"
                defaultValue={defaultValue}
                style={{ width: '100%', ...selectStyle }}
                onChange={handleChange}
                options={options}
                dropdownMatchSelectWidth={false}
                dropdownClassName="selectPopupClassName"
                suffixIcon={<CaretDownOutlined />}
                {...otherProps}
            />
        </div>
    );
};

export default MySelect;
